import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IVehicleMovement } from './vehicle-movements.models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VehicleMovementsService {
  private readonly http = inject(HttpClient);

  public getVehicleMovements(vin: string): Observable<IVehicleMovement> {
    return this.http.get<IVehicleMovement>(
      `${environment.services.masterdata}/api/routes/${vin}?countDamages=true`
    );
  }
}
